// extracted by mini-css-extract-plugin
module.exports = {"container":"_10kPvOd","title":"_31eQ-f8","subtitle":"_IGYPhDM"};